import { HotkeyItemOptions } from '@mantine/hooks';

export type NavigateFunction = (path: string) => void;
export type LogoutFunction = () => Promise<void>;

export type HotkeyAction = (
  navigate?: NavigateFunction,
  logout?: LogoutFunction,
  event?: KeyboardEvent
) => void;

export interface HotkeyConfigItem {
  keys: string;
  action: HotkeyAction;
  options?: HotkeyItemOptions;
}

export interface HotkeyConfigItem {
  keys: string;
  action: HotkeyAction;
  options?: HotkeyItemOptions;
}

export const hotkeysConfig: HotkeyConfigItem[] = [
  {
    keys: 'mod+1',
    action: (navigate) => {
      if (navigate) navigate('/');
    },
  },
  {
    keys: 'mod+2',
    action: (navigate) => {
      if (navigate) navigate('/claims');
    },
  },
  {
    keys: 'mod+3',
    action: (navigate) => {
      if (navigate) navigate('/submissions');
    },
  },
  {
    keys: 'mod+4',
    action: (navigate) => {
      if (navigate) navigate('/remittances');
    },
  },
  {
    keys: 'mod+shift+p',
    action: (_navigate, logout, event) => {
      event.preventDefault();
      if (logout) logout();
    },
  },
];
